import React, { useEffect, useState } from "react";
import { useUnit } from "effector-react";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import {
  setPage,
  WashingStore,
} from "../../../../stores/WashingStore/WashingStore";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import { KeyboardWrapper, TextWrapper, Wrapper } from "./SendReceiptStyles";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import { sendReceiptEffect } from "../../../../stores/WashingStore/WashingStore.effects";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import CustomKeyboard from "../../../../components/CustomKeyboard/CustomKeyboard";

const SendReceipt: React.FC = () => {
  const { paymentId } = useUnit(WashingStore);

  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    const unsubscribeDone = sendReceiptEffect.doneData.watch(() => {
      toast.success(`Comprovante enviado com sucesso!`);
      handleNext();
    });
    const unsubscribeFail = sendReceiptEffect.fail.watch(() => {
      toast.error(`Falha ao enviar comprovante, tente novamente`);
    });
    const unsubscribeFinally = sendReceiptEffect.finally.watch(() => {
      setLoading(false);
    });

    return () => {
      unsubscribeFail();
      unsubscribeDone();
      unsubscribeFinally();
    };
  }, []);

  const handleNext = () => {
    setPage(PAGES.WASHING_PAYMENT_SUCCESS);
  };

  const handleSendReceipt = () => {
    if (email.length < 4) {
      toast.error("Preencha um email");
      return false;
    }

    const receipt = {
      paymentId,
      email,
    };

    sendReceiptEffect(receipt);
    setLoading(true);
  };

  const Buttons = (
    <>
      <TotemButton onClick={() => handleNext()} text="Pular" />
      <TotemButton
        onClick={() => handleSendReceipt()}
        disabled={!email || email.length < 4}
        text="Enviar"
      />
    </>
  );

  return (
    <TotemSkeleton title="Envio do Comprovante" buttons={Buttons}>
      <Wrapper>
        <TextWrapper>
          <TextField
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="E-mail"
            variant="outlined"
            slotProps={{
              htmlInput: { style: { fontSize: 32, textAlign: 'center' } }
            }}
            style={{ marginBottom: "2rem", fontSize: "2rem" }}
          />
        </TextWrapper>
        <KeyboardWrapper>
          <CustomKeyboard setValue={setEmail} />
        </KeyboardWrapper>
      </Wrapper>
    </TotemSkeleton>
  );
};

export default SendReceipt;
